module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', {
    staticClass: "font-weight-bold",
    attrs: {
      "width": "100%"
    }
  }, [_vm._v("\n        Detail Soal\n\n        "), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-2",
    attrs: {
      "width": "100%"
    }
  }, [_c('v-card', {
    staticClass: "py-5 pa-5",
    attrs: {
      "flat": ""
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "grey--text font-size-14 py-2",
    attrs: {
      "md": "4"
    }
  }, [_vm._v("\n                    Kode\n                ")]), _vm._v(" "), _c('v-col', {
    staticClass: "font-weight-500 font-size-14 py-2",
    attrs: {
      "md": "7"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.details.kode || "-") + "\n                ")]), _vm._v(" "), _c('v-col', {
    staticClass: "grey--text font-size-14 py-2",
    attrs: {
      "md": "4"
    }
  }, [_vm._v("\n                    Mata Pelajaran\n                ")]), _vm._v(" "), _c('v-col', {
    staticClass: "py-2 font-weight-500 font-size-14",
    attrs: {
      "md": "7"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.details.mapel.nama || "-") + "\n                ")]), _vm._v(" "), _c('v-col', {
    staticClass: "grey--text font-size-14 py-2",
    attrs: {
      "md": "4"
    }
  }, [_vm._v("\n                    Bab\n                ")]), _vm._v(" "), _c('v-col', {
    staticClass: "py-2 font-weight-500 font-size-14",
    attrs: {
      "md": "7"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.details.bab.nama || "-") + "\n                ")]), _vm._v(" "), _c('v-col', {
    staticClass: "grey--text font-size-14 py-2",
    attrs: {
      "md": "4"
    }
  }, [_vm._v("\n                    Sub Bab\n                ")]), _vm._v(" "), _c('v-col', {
    staticClass: "py-2 font-weight-500 font-size-14",
    attrs: {
      "md": "7"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.details.sub_bab ? _vm.details.sub_bab.nama : "-") + "\n                ")]), _vm._v(" "), _c('v-col', {
    staticClass: "grey--text font-size-14 py-2",
    attrs: {
      "md": "4"
    }
  }, [_vm._v("\n                    Sub Sub Bab\n                ")]), _vm._v(" "), _c('v-col', {
    staticClass: "py-2 font-weight-500 font-size-14",
    attrs: {
      "md": "7"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.details.sub_sub_bab ? _vm.details.sub_sub_bab.nama : "-") + "\n                ")]), _vm._v(" "), _c('v-col', {
    staticClass: "grey--text font-size-14 py-2",
    attrs: {
      "md": "4"
    }
  }, [_vm._v("\n                    Jenjang\n                ")]), _vm._v(" "), _c('v-col', {
    staticClass: "py-2 font-weight-500 font-size-14",
    attrs: {
      "md": "7"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.details.jenjang ? _vm.details.jenjang.nama : "-") + "\n                ")]), _vm._v(" "), _c('v-col', {
    staticClass: "grey--text font-size-14 py-2",
    attrs: {
      "md": "4"
    }
  }, [_vm._v("\n                    Kelas\n                ")]), _vm._v(" "), _c('v-col', {
    staticClass: "py-2",
    attrs: {
      "md": "7"
    }
  }, [_c('div', _vm._l((_vm.details.grades
    .slice()
    .sort(function (a, b) { return a.grade - b.grade; })), function(grade, i) {
    return _c('v-chip', {
      key: i,
      staticClass: "mr-2 mb-2 blew--text font-weight-600",
      attrs: {
        "input-value": true,
        "color": "lightblue"
      }
    }, [_vm._v("\n                            " + _vm._s(grade.display_name || "-") + "\n                        ")])
  }), 1)]), _vm._v(" "), _c('v-col', {
    staticClass: "grey--text font-size-14 py-2",
    attrs: {
      "md": "4"
    }
  }, [_vm._v("\n                    Tipe Pilihan\n                ")]), _vm._v(" "), _c('v-col', {
    staticClass: "py-2 font-weight-500 font-size-14",
    attrs: {
      "md": "7"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.details.tipe_pilihan || "-") + "\n                ")]), _vm._v(" "), _c('v-col', {
    staticClass: "grey--text font-size-14 py-2",
    attrs: {
      "md": "4"
    }
  }, [_vm._v("\n                    Tingkat Kesulitan\n                ")]), _vm._v(" "), _c('v-col', {
    staticClass: "py-2 font-weight-500 font-size-14",
    attrs: {
      "md": "7"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.details.difficulty_level || "-") + "\n                ")]), _vm._v(" "), _c('v-col', {
    staticClass: "grey--text font-size-14 py-2",
    attrs: {
      "md": "4"
    }
  }, [_vm._v("\n                    Eigen\n                ")]), _vm._v(" "), _c('v-col', {
    staticClass: "py-2 font-weight-500 font-size-14",
    attrs: {
      "md": "7"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.details.nilai_eigen || "-") + "\n                ")]), _vm._v(" "), _c('v-col', {
    staticClass: "grey--text font-size-14 py-2",
    attrs: {
      "md": "4"
    }
  }, [_vm._v("\n                    Label\n                ")]), _vm._v(" "), _c('v-col', {
    staticClass: "py-2 font-weight-500 font-size-14",
    attrs: {
      "md": "7"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.details.label || "-") + "\n                ")]), _vm._v(" "), _c('v-col', {
    staticClass: "grey--text font-size-14 py-2",
    attrs: {
      "md": "4"
    }
  }, [_vm._v("\n                    Status Dimunculkan\n                ")]), _vm._v(" "), _c('v-col', {
    staticClass: "py-2 font-weight-500 font-size-14",
    attrs: {
      "md": "7"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.details.is_restricted) + "\n                ")])], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "my-7"
  }), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "grey--text font-size-14 py-2",
    attrs: {
      "md": "4"
    }
  }, [_vm._v("\n                    Dibuat Tanggal\n                ")]), _vm._v(" "), _c('v-col', {
    staticClass: "py-2 font-weight-500 font-size-14",
    attrs: {
      "md": "7"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.created_date) + "\n                ")]), _vm._v(" "), _c('v-col', {
    staticClass: "grey--text font-size-14 pt-3 pb-1",
    attrs: {
      "md": "4"
    }
  }, [_vm._v("\n                    Status\n                ")]), _vm._v(" "), _c('v-col', [(!_vm.details.is_valid) ? _c('v-chip', {
    staticClass: "pl-1 pr-3 font-size-12 red--text font-weight-500",
    attrs: {
      "color": "#FFEBEE",
      "dark": ""
    }
  }, [_c('v-icon', {
    staticClass: "mr-1"
  }, [_vm._v("mdi-close-circle")]), _vm._v("\n                        Belum Tervalidasi\n                    ")], 1) : _c('v-chip', {
    staticClass: "pl-1 pr-3 font-size-12 green--text font-weight-500",
    attrs: {
      "color": "lightgreen",
      "dark": ""
    }
  }, [_c('v-icon', {
    staticClass: "mr-1"
  }, [_vm._v("mdi-check-circle")]), _vm._v("\n                        Sudah Divalidasi\n                    ")], 1)], 1)], 1), _vm._v(" "), (_vm.details.is_valid) ? [_c('v-row', [_c('v-col', {
    staticClass: "grey--text font-size-14 py-2",
    attrs: {
      "md": "4"
    }
  }, [_vm._v("\n                        Di Validasi Oleh\n                    ")]), _vm._v(" "), _c('v-col', {
    staticClass: "py-2 font-weight-500 font-size-14",
    attrs: {
      "md": "8"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.details.pic_vailidate || "-") + "\n                    ")]), _vm._v(" "), _c('v-col', {
    staticClass: "grey--text font-size-14 py-2",
    attrs: {
      "md": "4"
    }
  }, [_vm._v("\n                        Di Validasi Tanggal\n                    ")]), _vm._v(" "), _c('v-col', {
    staticClass: "py-2 font-weight-500 font-size-14",
    attrs: {
      "md": "8"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$moment(_vm.details.updated_at).format(
    "DD MMM YYYY"
  ) || "-") + "\n                    ")])], 1)] : _vm._e()], 2)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "py-4"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n            Kembali\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blew",
      "depressed": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('preview')
      }
    }
  }, [_vm._v("\n            Preview\n        ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed6d0cc8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/itembank/components/Detail.vue
// module id = 1538
// module chunks = 1